export default class StockChecker {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el;
        this.data = parent.data;
        this.car = parent.car;
        this.carManager = parent.carManager;
        this.enabled = !!this.data.stock;
    }

    isMTOInStock(mto) {
        return mto ? this.data.stock?.some((mtoc) => mtoc.startsWith(`${mto}`)) : false;
    }

    isMTOCInStock(mtoc) {
        return mtoc ? this.data.stock?.includes(mtoc) : false;
    }

    isCarInStock(car) {
        return car ? this.isMTOCInStock(car?.mtoc()) : false;
    }

    isColourInStock(colour) {
        const tempCar = this.carManager.set('colour', colour, true);
        return this.isCarInStock(tempCar);
    }

    isTrimInStock(trim) {
        const tempCar = this.carManager.set('trim', trim, true);
        return this.isCarInStock(tempCar);
    }
    
}